import { render, staticRenderFns } from "./CaseStudies.vue?vue&type=template&id=31f45f0f&scoped=true"
import script from "./CaseStudies.vue?vue&type=script&lang=ts"
export * from "./CaseStudies.vue?vue&type=script&lang=ts"
import style0 from "./CaseStudies.vue?vue&type=style&index=0&id=31f45f0f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f45f0f",
  null
  
)

export default component.exports